var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenAlgae(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 30,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 39,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 39,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 53,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 53,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 66,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 66,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 70,
    r: 13,
    fill: "#C8E6C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 30,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 27,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 39,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 36,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 39,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 36,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 53,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 50,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 53,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 50,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 66,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 63,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 66,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 63,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 70,
    r: 10,
    fill: "#2E9E5B",
    stroke: "#1B7A4B",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 67,
    r: 3,
    fill: "#A5D6A7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 46,
    r: 3.2,
    fill: "#FFEE93",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 57,
    r: 3.2,
    fill: "#FFEE93",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 60,
    r: 3.2,
    fill: "#FFEE93",
    opacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAlgae);
export default __webpack_public_path__ + "static/media/green_algae.aa91e8da815d24d728f9398b5bc623aa.svg";
export { ForwardRef as ReactComponent };